const VideoPreview = ({ fileKey, url, type }) => {
  return (
    <div className="relative w-full h-full">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        controls
        muted
      >
        <source src={url} type={type} />
      </video>
    </div>
  );
};

export default VideoPreview;
